var _path, _path2, _path3, _ellipse, _circle, _ellipse2, _circle2, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPetdetection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.005 149.937C132.782 141.55 145.279 128.101 152.487 111.752C159.696 95.4035 161.196 77.1056 156.747 59.8011C152.298 42.4966 142.159 27.1911 127.96 16.3461C113.76 5.50103 96.326 -0.253269 78.4607 0.00854954C60.5954 0.270368 43.3372 6.53309 29.4617 17.7896C15.5862 29.046 5.89966 44.642 1.9599 62.0695C-1.97985 79.497 0.0561258 97.7431 7.74041 113.873C15.4247 130.004 28.3107 143.081 44.3262 151.002L48.6753 142.209C34.6329 135.264 23.3344 123.798 16.5968 109.654C9.85925 95.5112 8.07411 79.5131 11.5285 64.2326C14.9829 48.9522 23.476 35.2776 35.6421 25.4079C47.8082 15.5383 62.9401 10.0471 78.6044 9.81754C94.2688 9.58798 109.555 14.6334 122.005 24.1423C134.455 33.6512 143.345 47.0711 147.246 62.2437C151.147 77.4163 149.831 93.4599 143.511 107.794C137.191 122.129 126.233 133.921 112.4 141.275L117.005 149.937Z",
    fill: "url(#paint0_linear_1839_2020)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.005 149.937C132.782 141.55 145.279 128.101 152.487 111.752C159.696 95.4035 161.196 77.1056 156.747 59.8011C152.298 42.4966 142.159 27.1911 127.96 16.3461C113.76 5.50103 96.326 -0.253269 78.4607 0.00854954C60.5954 0.270368 43.3372 6.53309 29.4617 17.7896C15.5862 29.046 5.89966 44.642 1.9599 62.0695C-1.97985 79.497 0.0561258 97.7431 7.74041 113.873C15.4247 130.004 28.3107 143.081 44.3262 151.002L48.6753 142.209C34.6329 135.264 23.3344 123.798 16.5968 109.654C9.85925 95.5112 8.07411 79.5131 11.5285 64.2326C14.9829 48.9522 23.476 35.2776 35.6421 25.4079C47.8082 15.5383 62.9401 10.0471 78.6044 9.81754C94.2688 9.58798 109.555 14.6334 122.005 24.1423C134.455 33.6512 143.345 47.0711 147.246 62.2437C151.147 77.4163 149.831 93.4599 143.511 107.794C137.191 122.129 126.233 133.921 112.4 141.275L117.005 149.937Z",
    fill: "url(#paint1_linear_1839_2020)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0564 98.6261C91.2496 99.8399 98.7593 93.2237 95.4655 85.6242C94.6664 83.7806 93.724 82.1391 92.6489 80.8649C88.8333 76.3428 83.6583 73.8022 78.2623 73.8022C72.8662 73.8022 67.6912 76.3428 63.8756 80.8649C62.8005 82.1391 61.8581 83.7806 61.0591 85.6242C57.7652 93.2237 65.2749 99.8399 73.4681 98.6261L76.2745 98.2103C77.5925 98.015 78.932 98.015 80.25 98.2103L83.0564 98.6261Z",
    stroke: "white",
    strokeWidth: 3.39097
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.6082,
    cy: 73.8028,
    rx: 3.39097,
    ry: 3.39097,
    stroke: "white",
    strokeWidth: 2.71278
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7407,
    cy: 65.325,
    r: 5.08646,
    stroke: "white",
    strokeWidth: 3.39097
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.9194,
    cy: 73.8028,
    rx: 3.39097,
    ry: 3.39097,
    stroke: "white",
    strokeWidth: 2.71278
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.786,
    cy: 65.325,
    r: 5.08646,
    stroke: "white",
    strokeWidth: 3.39097
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1003 46.7854C49.2052 46.7854 46.0475 49.9431 46.0475 53.8382V60.5382C46.0475 61.3173 45.416 61.9488 44.637 61.9488C43.858 61.9488 43.2265 61.3173 43.2265 60.5382V53.8382C43.2265 48.385 47.6471 43.9644 53.1003 43.9644H59.4477C60.2267 43.9644 60.8583 44.5959 60.8583 45.3749C60.8583 46.1539 60.2267 46.7854 59.4477 46.7854H53.1003ZM96.1219 45.3749C96.1219 44.5959 96.7534 43.9644 97.5324 43.9644H103.88C109.333 43.9644 113.754 48.385 113.754 53.8382V60.5383C113.754 61.3173 113.122 61.9488 112.343 61.9488C111.564 61.9488 110.933 61.3173 110.933 60.5383V53.8382C110.933 49.9431 107.775 46.7854 103.88 46.7854H97.5324C96.7534 46.7854 96.1219 46.1539 96.1219 45.3749ZM44.637 99.3282C45.416 99.3282 46.0475 99.9598 46.0475 100.739V107.439C46.0475 111.334 49.2052 114.492 53.1003 114.492H59.4477C60.2267 114.492 60.8583 115.123 60.8583 115.902C60.8583 116.681 60.2267 117.313 59.4477 117.313H53.1003C47.6471 117.313 43.2265 112.892 43.2265 107.439V100.739C43.2265 99.9598 43.858 99.3282 44.637 99.3282ZM112.343 99.3282C113.122 99.3282 113.754 99.9598 113.754 100.739V107.439C113.754 112.892 109.333 117.313 103.88 117.313H97.5324C96.7534 117.313 96.1219 116.681 96.1219 115.902C96.1219 115.123 96.7534 114.492 97.5324 114.492H103.88C107.775 114.492 110.933 111.334 110.933 107.439V100.739C110.933 99.9598 111.564 99.3282 112.343 99.3282Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1839_2020",
    x1: -0.00000324536,
    y1: 159.255,
    x2: 172.302,
    y2: 15.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1839_2020",
    x1: 79.6275,
    y1: 0,
    x2: 79.6275,
    y2: 159.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943585,
    stopColor: "#121212"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetdetection);
export default __webpack_public_path__ + "static/media/petdetection.d09a9f505ef0956ae130413dc25e5604.svg";
export { ForwardRef as ReactComponent };